/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectNoteData
 */
export interface CrmProjectNoteData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectNoteData
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectNoteData
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectNoteData
     */
    authorUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectNoteData
     */
    authorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectNoteData
     */
    authorEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectNoteData
     */
    body?: string;
}

/**
 * Check if a given object implements the CrmProjectNoteData interface.
 */
export function instanceOfCrmProjectNoteData(value: object): value is CrmProjectNoteData {
    return true;
}

export function CrmProjectNoteDataFromJSON(json: any): CrmProjectNoteData {
    return CrmProjectNoteDataFromJSONTyped(json, false);
}

export function CrmProjectNoteDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectNoteData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'authorUserId': json['authorUserId'] === undefined ? undefined : json['authorUserId'] === null ? null : json['authorUserId'],
        'authorName': json['authorName'] === undefined ? undefined : json['authorName'] === null ? null : json['authorName'],
        'authorEmail': json['authorEmail'] === undefined ? undefined : json['authorEmail'] === null ? null : json['authorEmail'],
        'body': json['body'] == null ? undefined : json['body'],
    };
}

export function CrmProjectNoteDataToJSON(json: any): CrmProjectNoteData {
    return CrmProjectNoteDataToJSONTyped(json, false);
}

export function CrmProjectNoteDataToJSONTyped(value?: CrmProjectNoteData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'authorUserId': value['authorUserId'],
        'authorName': value['authorName'],
        'authorEmail': value['authorEmail'],
        'body': value['body'],
    };
}

